import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  AppAudioPlayerControlsRepeat,
  AppAudioPlayerControlsRepeatCurent
} from '@elfsight/icons';
import { getColorWithAlpha } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import type { PropsWithClassName } from '../../../../../types';
import { useTheme } from '../../../common';
import { usePlayer } from '../../PlayerProvider';
import type { DefaultButtonProps } from './DefaultButton';
import { DefaultButton } from './DefaultButton';
import { Icon } from './Icon';

export function Loop({
  className,
  ...forwardingProps
}: PropsWithClassName<DefaultButtonProps>) {
  const {
    accentColor,
    sourceType,
    messageNoRepeat,
    messageRepeatPlaylist,
    messageRepeatTrack
  } = useSettings();
  const { textColor } = useTheme();
  const [title, setTitle] = useState(messageNoRepeat);
  const { loopTrack, setLoopTrack, loopPlaylist, setLoopPlaylist } =
    usePlayer();

  const noLoops = !loopTrack && !loopPlaylist;

  const onClick = useCallback(() => {
    if (noLoops) {
      setLoopPlaylist(true);
    } else if (loopPlaylist) {
      setLoopPlaylist(false);
      setLoopTrack(true);
    } else if (loopTrack) {
      setLoopTrack(false);
      setLoopPlaylist(false);
    }
  }, [loopPlaylist, loopTrack, setLoopPlaylist, setLoopTrack]);

  useEffect(() => {
    if (noLoops) {
      setTitle(messageNoRepeat);
    } else if (loopPlaylist) {
      setTitle(messageRepeatPlaylist);
    } else if (loopTrack) {
      setTitle(messageRepeatTrack);
    }
  }, [loopPlaylist, loopTrack, messageNoRepeat]);

  return (
    sourceType !== 'rss' &&
    sourceType !== 'radio' && (
      <LoopComponent
        {...forwardingProps}
        className={className}
        onClick={onClick}
        title={title}
      >
        {noLoops && (
          <Icon
            as={AppAudioPlayerControlsRepeat}
            fill={getColorWithAlpha(textColor, 0.5)}
          />
        )}
        {loopTrack && (
          <Icon as={AppAudioPlayerControlsRepeatCurent} fill={accentColor} />
        )}
        {loopPlaylist && (
          <Icon as={AppAudioPlayerControlsRepeat} fill={accentColor} />
        )}
      </LoopComponent>
    )
  );
}

export const LoopComponent = styled(DefaultButton)``;
